<template>
  <div class="left-menu">
    <el-scrollbar ref="menuScroller" class="menu-scroll">
      <div class="console-sec-menu" :style="isCollapse?'':'width:200px'">
        <!-- <div class="console-sec-menu-text">{{ menuData.text }}</div> -->
        <el-scrollbar ref="menuScroller" class="menu-scroll">
          <el-menu class="tower-menu" background-color="#ffffff" router text-color="#0C0D0E" active-text-color="#0055FF" :default-active="active" :collapse="isCollapse" :collapse-transition="true" :unique-opened="false" mini-style>
            <tree :data="menuItem" :show-icon="true" />
          </el-menu>
        </el-scrollbar>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Tree from "./tree";
import ConsoleMenuSearch from "./ConsoleMenuSearch.vue";
export default {
  components: {
    Tree,
    ConsoleMenuSearch,
  },
  props: {
    menuData: {
      type: Object,
    },
  },
  computed: {
    active: function () {
      return this.$route.path;
    },
    menuItem: function () {
      return this.menuData.children;
    },
    ...mapGetters({
      rootMenu: "user/menu",
      isCollapse: "layout/isCollapse",
    }),
  },

  data() {
    return {
      showSearch: false,
      pathname: "",
    };
  },
  methods: {
    ...mapActions(["user/setMenuActiveOne", "user/setMenuActive"]),
    menuSelect(index) {
      menuClickLog(this, index);
    },

  },
  mounted() {
    this.pathname = window.location.pathname;
  },
};
</script>
<style>
.left-menu {
  width: 102%;
  height: 95%;
}

.console-sec-menu-text {
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #b5c2d9;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  color: #b5c2d9;
}

.console-meun > li {
  color: #ccc;
  color: #303133;
  padding: 10px 5px 10px 5px;
  list-style: none;
  cursor: pointer;
  position: relative;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  box-sizing: border-box;
}

.console-meun > li.active {
  background: #2a2f32;
  /* border-left: 2px solid #fff; */
}

.console-meun > li:first-child {
  height: 31px;
  line-height: 31px;
  padding: 0;
  background: #3a3f49;
}

.console-meun > li > div.root-menu {
  text-align: center;
}

.console-meun > li.active > div > i {
  color: #fff;
}

.console-meun > li > div > i {
  color: #ccc;
  margin: 0;
  vertical-align: middle;
  width: 22px;
  font-size: 22px;
  text-align: center;
}

.console-meun > li.active > div > p {
  color: #fff;
}

.console-meun > li > div > p {
  color: #ccc;
  font-size: 12px;
}

.console-sec-menu {
  position: fixed;
  background: #ffffff;
  left: 0;
  color: #b5c2d9;
  top: 50px;
  bottom: 0;
  height: 90%;
}

/*
  .console-sec-menu::before {
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-right: 6px solid transparent;
    border-right-color: rgb(255 255 255 / 0.90);
    content: '';
    position: absolute;
    left: -12px;
    top: 10px;
  } */

.console-sec-menu .el-submenu .el-menu-item {
  min-width: 100px;
}

.console-sec-menu .el-menu-item {
  height: 45px;
  line-height: 40px;
  font-size: 14px;
  /* padding-bottom: 5px; */
  padding-left: 20px !important;
}

.console-sec-menu .el-menu-item.is-active {
  background-color: #edf6ff !important;
  border-left: 2px solid #0055ff;
}

.console-sec-menu .el-menu-item{
  /* background-color: rgb(52, 68, 98) !important; */

}


.console-sec-menu .el-submenu__title {
  height: 45px;
  line-height: 40px;
  font-size: 14px;
  /* padding-bottom: 5px; */
  padding-left: 20px !important;
}

.console-sec-menu .el-submenu__icon-arrow {
  right: 10px;
}

.sec-menu {
  display: inline-block;
  width: 100px;
  top: 0;
  position: relative;
  vertical-align: top;
  color: #fff;
  padding: 10px;
  overflow: hidden;
}

.sec-menu-scroll .el-scrollbar__wrap {
  overflow-x: hidden;
}

.sec-menu-scroll {
  height: 500px;
  overflow: hidden;
}

.chd-menu-text {
  color: #999;
}

.chd-menu-text.bold {
  font-weight: bold;
  color: #fff;
  font-size: 12px;
}

.chd-menu-wrap > div > .chd-menu-text {
  padding-left: 20px !important;
}

.chd-menu-wrap .chd-menu-wrap {
  padding-left: 20px !important;
}

.chd-menu-text:hover {
  color: #409eff;
}

.sec-menu span {
  padding: 5px;
  display: block;
}

.el-menu.tower-menu {
  margin-bottom: 50px;
}

.left-menu.is-active {
  /* background-color: #000000 !important; */
}

.el-submenu.is-active > .el-submenu__title {
  /* background-color: #000000 !important; */
  color: #0055ff !important;
}

.el-submenu.is-active > .el-submenu__title i {
  /* background-color: #000000 !important; */
  color: #0055ff !important;
}

.el-submenu.is-active .el-menu .el-menu-item.is-active {
  background-color: #edf6ff !important;
  border-left: 2px solid #0055ff;
}

.el-submenu.is-active .el-menu .el-menu-item {
  /* background-color: #000000 !important; */
}

.el-submenu .el-menu .el-menu-item {
  padding-left: 50px !important;
  background-color: #fafafa !important;
}

.el-submenu .el-menu .el-submenu .el-submenu__title {
  padding-left: 50px !important;
  background-color: #fafafa !important;
}

.el-submenu .el-menu .el-submenu .el-menu .el-menu-item {
  padding-left: 70px !important;
}

.el-menu--collapse .el-submenu__title{
  padding-left: 20px !important;
}
</style>
